import React, { ReactElement, useContext, useEffect } from 'react';

import Modal from '../../../../../../../shared/components/modal/Modal';
import { ModalContext } from '../../../../../../../shared/components/modal/ModalContext';
import { ModalContextModel } from '../../../../../../../shared/components/modal/models/modal-context.model';
import useDeleteModal from '../../../../../../../shared/hooks/use-delete-modal/use-delete-modal';
import { ReviewModel } from '../../../../models/review.model';
import { deleteReview } from '../../../../thunks/delete-review.thunk';
import { getReviewsTotalCount } from '../../../../thunks/get-reviews-total-count.thunk';
import { getReviews } from '../../../../thunks/get-reviews.thunk';
import { GetReviewsPathParams } from '../../../../thunks/models/get-reviews-params.model';
import { ReviewsHeaderAndPaginationFilters } from '../../../../thunks/models/reviews-header-and-pagination-filters.model';

export const useShowDeleteReviewsModal = (
  ids: number[],
  filters?: Partial<ReviewsHeaderAndPaginationFilters>,
  appId?: string
): ReactElement => {
  const ctx = useContext(ModalContext) as ModalContextModel;

  const deleteModal = useDeleteModal<
    void,
    number,
    ReviewModel[],
    GetReviewsPathParams,
    number,
    GetReviewsPathParams
  >({
    ids: ids,
    deleteAction: deleteReview,
    param: { appId: parseInt(appId as string, 10), filters },
    afterDeleteAction: getReviews,
    resetTotalCountParams: { appId: parseInt(appId as string, 10), filters },
    resetTotalCount: getReviewsTotalCount,
  });

  useEffect(() => {
    if (ids.length && !ctx.isOpen) {
      ctx.componentHandler(deleteModal);
      ctx.modalStateHandler();
    }
  }, [ids]);

  return <Modal>{ctx.component}</Modal>;
};
